import { ProcessesTemplates } from '@entities';

const Processes = () => <ProcessesTemplates />;

export default Processes;
